import React, { useContext } from 'react';
import { Container, Typography } from '@pwskills/rachnaui';
import Slider from '@pwskills/rachnaui/components/Slider';
import Headers from '@/components/common/Header';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { useRouter } from 'next/router';
import ToolsCard from './ToolsCard';

const ToolsSection = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { masterTools } = courseDetails?.courseMetaDetails || {};
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  const returnChildren = () => {
    return (
      <>
        {isDashboard ? (
          <Typography component="h4" variant="semi-bold">
            Master these Tools
          </Typography>
        ) : (
          <Headers
            title="Master these Tools"
            classes="flex justify-center text-gray-850 !min-w-full"
          />
        )}

        <Slider
          className="[&>*]:w-full gap-5 my-[30px]"
          iconWrapperClass="-mt-4 !pb-5"
          // autoPlay
          positionOfSliderInMobile="bottom"
        >
          {masterTools?.map((company) => (
            <ToolsCard company={company} key={company?._id} />
          ))}
        </Slider>
      </>
    );
  };
  if (masterTools && masterTools.length > 0)
    if (isDashboard) return <div className="flex flex-col gap-4  p-4">{returnChildren()}</div>;
    else
      return (
        <div className="bg-gradient-to-b  from-white to-[#FCFCFC]">
          <Container className="py-8 large:!py-14 flex flex-col gap-4 medium:gap-8 large:gap-14">
            {returnChildren()}
          </Container>
        </div>
      );

  return null;
};

export default ToolsSection;
